<template>
  <div class="wrap animate__animated animate__fadeIn">
    <div class="title">
      <span>监控画面</span>
      <div class="btn_playback" @click="fnInitIframe('rec')"><span>查看回放</span></div>
      <div class="btn_ysycontrol" @click="ysyShowSet = !ysyShowSet"><span>云台控制</span></div>
      <div class="control_list" v-if="ysyShowSet">
        <div class="list_left">
          <div class="left_top">
            <div class="control_btn" :class="selectScreen.speed == 0 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(0)"><span>慢</span></div>
          </div>
          <div class="left_center">
            <div class="control_btn" :class="selectScreen.speed == 1 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(1)"><span>适中</span></div>
          </div>
          <div class="left_bottom">
            <div class="control_btn" :class="selectScreen.speed == 2 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(2)"><span>快</span></div>
          </div>
        </div>
        <div class="list_center">
          <div class="center_top">
            <div
              class="control_btn blue f-20"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 8, speed: selectScreen.speed })"
            >
              <span><svg-icon icon-class="icon-enlarge" /></span>
            </div>
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 10, speed: selectScreen.speed })"
            >
              <span><svg-icon icon-class="icon-focus-close" /></span>
            </div>
          </div>
          <div class="center_center">
            <div
              class="control_btn blue f-20"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 9, speed: selectScreen.speed })"
            >
              <span><svg-icon icon-class="icon-narrow" /></span>
            </div>
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 11, speed: selectScreen.speed })"
            >
              <span><svg-icon icon-class="icon-focus-far" /></span>
            </div>
          </div>
          <div class="center_bottom"><div class="control_btn">(空)</div></div>
        </div>
        <div class="list_right">
          <div class="right_top">
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 4, speed: selectScreen.speed })"
            >
              <span>左上</span>
            </div>
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 0, speed: selectScreen.speed })"
            >
              <span>上</span>
            </div>
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 6, speed: selectScreen.speed })"
            >
              <span>右上</span>
            </div>
          </div>
          <div class="right_center">
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 2, speed: selectScreen.speed })"
            >
              <span>左</span>
            </div>
            <div class="control_btn">(空)</div>
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 3, speed: selectScreen.speed })"
            >
              <span>右</span>
            </div>
          </div>
          <div class="right_bottom">
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 5, speed: selectScreen.speed })"
            >
              <span>左下</span>
            </div>
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 1, speed: selectScreen.speed })"
            >
              <span>下</span>
            </div>
            <div
              class="control_btn blue"
              @click="fnControl({ deviceSerial: selectScreen.deviceSerial, channelNo: selectScreen.channelNo, direction: 7, speed: selectScreen.speed })"
            >
              <span>右下</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cont_box">
      <div class="box_left" :class="isLeftOpen ? 'open' : 'close'">
        <div class="close_btn" v-if="isLeftOpen" @click="isLeftOpen = false"><img src="../../../assets/img/left.png" /></div>
        <div class="open_btn" v-else @click="isLeftOpen = true"><img src="../../../assets/img/right.png" /></div>
        <div class="left_title">监控列表</div>
        <div class="list_box">
          <div class="list_all">
            <div class="list_item" :class="item.selected ? 'active' : ''" v-for="(item, index) in screenList" :key="index" @click="fnChooseChannel(item, index)">
              <i class="el-icon-check yes" v-if="item.selected"></i>
              <div class="item_title">{{ index + 1 }}.{{ item.name ? item.name : '未命名' }}</div>
              <div class="item_img">
                <img :src="item.cover" v-if="item.cover" />
                <img src="../../../assets/img/nos.png" v-else />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box_screen">
        <iframe :src="iframeSrc" v-if="iframeSrc" id="ysOpenDevice" allowfullscreen></iframe>
        <img src="../../../assets/images/no.png" v-else />
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import fnRequest from '@/utils/monitor';
import EZUIKit from '../../../../static/ezuikit';
import { getEqptInfo, removeEqptInfo } from '@/utils/auth';

export default {
  data() {
    return {
      isLeftOpen: true,
      monitorToken: '', // 视频监控token
      screenList: [],
      selectScreen: null,
      iframeSrc: null,
      ysyShowSet: false,
      isIndex: false,
      indexMsg: null
    };
  },
  mounted() {
    let _msg = getEqptInfo();
    if (_msg && _msg.pointType == '视频监控') {
      this.isIndex = true;
      let obj = {
        deviceSerial: _msg.pointNumber.split('-')[0],
        channelNo: _msg.pointNumber.split('-')[1]
      };
      this.indexMsg = obj;
    }
    // this.fnGetMonitorToken();
    this.fnInit();
  },
  beforeDestroy() {
    removeEqptInfo();
  },
  methods: {
    // 初始化
    fnInit() {
      this.fnGetData(res => {
        if (res.code == 1) {
          let _data = res.data;
          let _arr = [];
          for (let i in _data) {
            let _deviceSerial = _data[i].deviceSerial;
            let _app_key = _data[i].app_key;
            let _channel = _data[i].channel ? JSON.parse(_data[i].channel) : {};
            for (let j in _channel) {
              _channel[j].deviceSerial = _deviceSerial;
              _channel[j].app_key = _app_key;
              _arr.push(_channel[j]);
            }
          }
          for (let i in _arr) {
            let _index1 = _arr[i].liveAddress.lastIndexOf(':');
            _arr[i].liveAddress = 'https' + _arr[i].liveAddress.slice(_index1);
            let _index2 = _arr[i].hdAddress.lastIndexOf(':');
            _arr[i].hdAddress = 'https' + _arr[i].hdAddress.slice(_index2);
            _arr[i].selected = false;
            _arr[i].speed = 1;
          }
          this.screenList = _arr;
          if (this.screenList.length > 0) {
            if (this.isIndex) {
              for (let i in this.screenList) {
                if (this.screenList[i].deviceSerial == this.indexMsg.deviceSerial && this.screenList[i].channelNo == this.indexMsg.channelNo) {
                  this.selectScreen = this.screenList[i];
                  this.screenList[i].selected = true;
                  if (this.screenList[i].app_key === null) {
                    this.fnGetMonitorToken();
                  } else {
                    this.fnGetMonitorToken(this.selectScreen.deviceSerial);
                  }
                }
              }
            } else {
              this.selectScreen = this.screenList[0];
              this.screenList[0].selected = true;
              if (this.screenList[0].app_key === null) {
                this.fnGetMonitorToken();
              } else {
                this.fnGetMonitorToken(this.selectScreen.deviceSerial);
              }
            }
          }
        }
      });
    },
    // 获取监控数据
    fnGetData(_cb) {
      request({
        url: 'zgj-monitor/getMonitorList',
        methods: 'GET'
      })
        .then(res => {
          _cb && _cb(res);
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 获取监控地址token
    fnGetMonitorToken(_deviceSerial) {
      let _obj = {};
      if (_deviceSerial) {
        _obj.deviceSerial = _deviceSerial;
      }
      fnRequest({
        url: 'get_token',
        method: 'GET',
        params: _obj
      })
        .then(res => {
          this.monitorToken = res.data;
          this.fnInitIframe('live');
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 切换通道
    fnChooseChannel(item, index) {
      if (item.channelNo == this.selectScreen.channelNo && item.deviceSerial == this.selectScreen.deviceSerial) return;
      for (let i in this.screenList) {
        this.screenList[i].selected = false;
      }
      this.screenList[index].selected = true;
      this.selectScreen = item;
      if (item.app_key === null) {
        this.fnGetMonitorToken();
      } else {
        this.fnGetMonitorToken(item.deviceSerial);
      }
    },
    // 初始化回放
    fnInitIframe(type) {
      let url =
        'https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/' +
        this.selectScreen.deviceSerial +
        '/' +
        this.selectScreen.channelNo +
        '.' +
        type +
        '&autoplay=1&accessToken=' +
        this.monitorToken;
      this.$nextTick(() => {
        this.iframeSrc = url;
      });
    },
    // 选择设备速度
    fnSelectOneSpeed(_value) {
      this.selectScreen.speed = _value;
    },
    // 控制设备
    fnControl(_data) {
      this.fnStartControl(_data);
      setTimeout(() => {
        this.fnStopControl(_data);
      }, 500);
    },
    // 开始控制
    fnStartControl(_data) {
      let _obj = {
        state: 'start',
        deviceSerial: _data.deviceSerial,
        channelNo: _data.channelNo,
        direction: _data.direction,
        speed: _data.speed
      };
      this.fnControlMonitor(_obj);
    },
    // 结束控制
    fnStopControl(_data) {
      let _obj = {
        state: 'stop',
        deviceSerial: _data.deviceSerial,
        channelNo: _data.channelNo,
        direction: _data.direction,
        speed: _data.speed
      };
      this.fnControlMonitor(_obj);
    },
    // 设备控制公共方法
    fnControlMonitor(_obj) {
      fnRequest({
        url: 'control_ysy',
        method: 'POST',
        data: _obj
      })
        .then(res => {})
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.wrap {
  width: 1920px;
  min-height: 830px;
  margin: 10px 0;
  @include flex-box(center, center, column);
  .title {
    width: 1920px;
    height: 60px;
    line-height: 60px;
    font-size: 28px;
    text-align: center;
    position: relative;
    .btn_playback,
    .btn_ysycontrol {
      position: absolute;
      left: 1380px;
      top: 10px;
      width: 106px;
      height: 32px;
      background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
      @include flex-box(center, center);
      span {
        margin-top: -5px;
      }
    }
    .btn_ysycontrol {
      left: 1500px;
    }
    .control_list {
      width: 270px;
      height: 115px;
      padding: 5px;
      position: absolute;
      z-index: 3;
      top: 50px;
      left: 1500px;
      border-radius: 5px;
      background-color: #091120;
      @include flex-box(flex-start);
      .list_left {
        width: 40px;
        height: 105px;
        @include flex-box(flex-start, center, column, wrap);
        .left_top,
        .left_center,
        .left_bottom {
          width: 40px;
          height: 35px;
          @include flex-box(center, center);
        }
      }
      .list_center {
        width: 90px;
        height: 105px;
        @include flex-box(flex-start, center, column, wrap);
        .center_top,
        .center_center,
        .center_bottom {
          width: 90px;
          height: 35px;
          @include flex-box(space-around, center);
        }
      }
      .list_right {
        width: 130px;
        height: 105px;
        @include flex-box(flex-start, center, column, wrap);
        .right_top,
        .right_center,
        .right_bottom {
          width: 130px;
          height: 35px;
          @include flex-box(space-between, center);
        }
      }
      .control_btn {
        width: 40px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #ffffff;
        border: none;
        cursor: pointer;
        @include flex-box(center, center);
        &.blue {
          background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
          background-size: 100% 100%;
        }
        &.yellow {
          background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
          background-size: 100% 100%;
        }
        &.big {
          width: 90px;
        }
        &.f-20 {
          font-size: 20px;
        }
        span {
          margin-top: -2px;
        }
      }
    }
  }
  .cont_box {
    width: 1920px;
    height: 770px;
    position: relative;
    @include flex-box();
    .box_left {
      width: 280px;
      height: 770px;
      border: 1px solid #1d4495;
      border-left: none;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      background-color: rgba(29, 68, 149, 0.1);
      left: 0;
      top: 0;
      position: absolute;
      &.close {
        left: -280px;
        transition: left 0.5s;
      }
      &.open {
        left: 0;
        transition: left 0.5s;
      }
      .open_btn,
      .close_btn {
        width: 50px;
        height: 60px;
        position: absolute;
        font-weight: bold;
        top: 355px;
        right: -50px;
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.3);
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        @include flex-box(center, center);
        img {
          width: 40px;
        }
      }
      .left_title {
        width: 280px;
        height: 40px;
        line-height: 40px;
        padding-left: 20px;
        color: #ffffff;
        font-size: 18px;
        border-top-right-radius: 10px;
        background-color: rgba(29, 68, 149, 0.3);
      }
      .list_box {
        width: 280px;
        height: 728px;
        position: relative;
        overflow: hidden;
        .list_all {
          position: absolute;
          left: 0;
          right: -20px;
          top: 0;
          bottom: 0;
          overflow-x: hidden;
          overflow-y: auto;
          @include flex-box(flex-start, flex-start, column);
          .list_item {
            margin: 20px 20px 0;
            width: 240px;
            height: 160px;
            border: 2px solid #1d4495;
            position: relative;
            &.active {
              border: 2px solid #ffa500;
            }
            &:last-child {
              margin-bottom: 20px;
            }
            .yes {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 30px;
              height: 30px;
              font-size: 26px;
              font-weight: bold;
              color: #ffa500;
            }
            .item_title {
              width: 236px;
              padding-left: 10px;
              height: 30px;
              line-height: 30px;
              position: absolute;
              top: 0;
              left: 0;
              color: #ffffff;
              font-size: 16px;
              font-family: '宋体';
              background-color: rgba(0, 0, 0, 0.3);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .item_img {
              width: 236px;
              height: 156px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
    .box_screen {
      width: 1320px;
      height: 770px;
      margin: 0 auto;
      border: 1px solid #1d4495;
      border-radius: 10px;
      iframe {
        width: 1318px;
        height: 768px;
        border-radius: 10px;
      }
      img {
        width: 1318px;
        height: 768px;
        border-radius: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MonitorScreen/MonitorScreenDefault/index.vue